import React from 'react';
import { useAtom } from 'jotai';
import { siteDataAtom } from '../../atoms/SiteDataAtom';
import { Card, CardBody, Table as BTable } from 'reactstrap';

const SiteInfoTable = () => {
  const [siteData] = useAtom(siteDataAtom);

  // Define the data as key-value pairs
  const data = [
    { key: 'Status', value: siteData.Status || '' },
    { key: 'Power', value: `${siteData.Pturb}kW` || 0 },
    { key: 'RPM', value: siteData.RPMMax || 0 },
        {
      key: 'Day kWh',
      value:
        typeof siteData.DaykWh === 'number'
          ? siteData.DaykWh.toFixed(3)
          : '0.000',
    },
    { key: 'Grid', value: `${siteData.Vgrid}V ${siteData.Fgrid}Hz` || 0 },
    { key: 'Vdc', value: siteData.Vdc || 0 },
  ];

  return (
    <Card style={{ maxHeight: '100%' }}>
      <CardBody>
        <BTable bordered hover responsive size="sm" className="mb-0">
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td
                  style={{
                    fontWeight: 'bold',
                    color: 'white',
                    backgroundColor: 'lightslategrey',
                    width: '30%',
                    textAlign: 'right',
                    paddingRight: '10px',
                  }}
                >
                  {item.key}
                </td>
                <td
                  style={{
                    width: '70%',
                  }}
                >
                  {item.value}
                </td>
              </tr>
            ))}
          </tbody>
        </BTable>
      </CardBody>
    </Card>
  );
};

export default SiteInfoTable;




